import { useEffect, useState } from "react";
import { Button, Checkbox, CircularProgress, FormControlLabel, Typography } from "@mui/material";
import { useMutation } from 'react-query'
import FlexibleWidthDialog from "components/Dialog/FlexibleWidthDialog"
import { editPermissions } from "../services/api";
import { useTranslation } from "react-i18next";
import i18n from "i18next";

export default function Permission({ open, close, instance, reportAction, extraData }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false)
  const [permissionsSelected, setPermissionsSelected] = useState([])
  const [group, setGroup] = useState([])
  const languageIndex = i18n.language === "es" ? 0 : 1

  useEffect(() => {
    let groupingViaCommonProperty = Object.values(
      extraData.permissionsList.reduce((acc, current) => {
        acc[current.group[languageIndex].text] = acc[current.group[languageIndex].text] ?? [];
        acc[current.group[languageIndex].text].push(current);
        return acc;
      }, {})
    );
    //console.log(groupingViaCommonProperty)
    setGroup(groupingViaCommonProperty)
    setPermissionsSelected(instance.permissions)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  const mutation = useMutation(editPermissions, {
    onSuccess: (data) => {
      setIsLoading(false)
      if (data.status === "error") { reportAction(false, 'Error al guardar los datos', 'error') } 
      else {
        reportAction(true, 'Acción realizada correctamente', 'success')
      }
    }
  })

  const handleEdit = () => {
    setIsLoading(true)
    mutation.mutate({ id: instance._id, permissions: permissionsSelected })
  }

  const handleClose = () => { close() }

  const Actions = () => (<>
    {!isLoading ? <>
      <Button onClick={handleClose}>{t("button_text_cancel")}</Button>
      <Button variant="contained" color="info" onClick={handleEdit}>{t("button_text_edit")}</Button>
    </> : <CircularProgress />}
  </>)

  const handleUpdatePermission = (id) => {
    let temp = [...permissionsSelected]
    let index = temp.indexOf(id)
    if (index !== -1) {
      temp.splice(index, 1)
    } else {
      temp.push(id)
    }
    setPermissionsSelected(temp)
  }

  return (<>
    <FlexibleWidthDialog open={open} title={t('users_dialog_title_permission')} actions={<Actions />}>
      <>
        {group.map((p, i) => (
        <div key={`${i}-container-group`}>
          <Typography component="p" variant="h6">{p[0].group[languageIndex].text}</Typography>
          { p.map((r, j) => (<>
            <FormControlLabel key={`${j}-${r._id}`} control={<Checkbox onClick={() => handleUpdatePermission(r.identifier)} />} label={r.descriptions[languageIndex].text} checked={permissionsSelected.includes(r.identifier)} /><br />
          </>))}
          <br/>
        </div>))}
      </>
    </FlexibleWidthDialog>
  </>)
}